import React, { useEffect, useMemo, useRef, useState } from 'react';
import api from '@common/utils/api';
import { extractNativeComponent, extractNativeRegionComponents } from '@common/utils/regions';
import '@stone/scss/components/gallery/_gallery.scss';
import useMediaQueries from '@stone/hooks/useMediaQueries';
import SwiperCore, { Navigation, A11y, Keyboard, Pagination } from 'swiper';
import GallerySimple from './GallerySimple';
SwiperCore.use([Keyboard, Navigation, A11y, Pagination]);
const GalleryUniform = React.lazy(() => import('./GalleryUniform'));
const Gallery = (props) => {
    // ANCHOR - HOOKS --------------------------------------------------------------------
    const containerRef = useRef(null);
    const mediaQueries = useMediaQueries();
    const { isDesktop, isTouch, isWideDesktop } = mediaQueries;
    // ANCHOR - STATES --------------------------------------------------------------------
    const [gallery, setGallery] = useState(null);
    const [slides, setSlides] = useState([]);
    // ANCHOR - MEMO --------------------------------------------------------------------
    const isCarouselTouch = useMemo(() => !isDesktop || (isTouch && !isWideDesktop), [isDesktop, isWideDesktop, isTouch]);
    const uniformProps = useMemo(() => {
        return {
            slides,
            id: gallery === null || gallery === void 0 ? void 0 : gallery.id,
            mediaQueries,
            ratio: gallery === null || gallery === void 0 ? void 0 : gallery.data.ratio,
        };
    }, [slides, gallery, mediaQueries]);
    const asymmetricProps = useMemo(() => {
        return {
            slides,
            id: gallery === null || gallery === void 0 ? void 0 : gallery.id,
            mediaQueries,
            alignement: gallery === null || gallery === void 0 ? void 0 : gallery.data.alignement,
            isIndented: gallery === null || gallery === void 0 ? void 0 : gallery.data.indented,
        };
    }, [slides, gallery, mediaQueries]);
    // ANCHOR - USEFFECTS --------------------------------------------------------------------
    useEffect(() => {
        api.getPageJson(props.pageId, true).then((res) => {
            if (res) {
                const gallery = extractNativeComponent(res, props.componentId);
                if (gallery) {
                    setGallery(gallery);
                    const slides = extractNativeRegionComponents(gallery, 'images');
                    if (slides === null || slides === void 0 ? void 0 : slides.length) {
                        setSlides(slides);
                    }
                }
            }
        });
    }, []);
    useEffect(() => {
        if (containerRef.current && isDesktop) {
            const observer = new ResizeObserver(() => {
                let maxHeight = 0;
                const videoStatusbar = containerRef.current.querySelectorAll('.editorial-video-statusbar');
                const labels = containerRef.current.querySelectorAll('.gallery-slide__labels');
                const _elements = [...videoStatusbar, ...labels];
                _elements.forEach((entry) => {
                    if (entry.clientHeight > maxHeight) {
                        maxHeight = entry.clientHeight;
                    }
                });
                const height = `${maxHeight / 10 + 1.6}rem`;
                const parentId = 'gallery-' + props.componentId;
                const parent = document.getElementById(parentId);
                parent.style.setProperty('--label-height', height);
            });
            observer.observe(containerRef.current);
            return () => {
                observer.disconnect();
            };
        }
    }, [isDesktop]);
    return (React.createElement("div", { ref: containerRef }, gallery && (slides === null || slides === void 0 ? void 0 : slides.length) && (React.createElement("div", { className: `gallery gallery--${props.type.toLowerCase()}` },
        props.type === 'UNIFORM' && (!isCarouselTouch ? React.createElement(GalleryUniform, Object.assign({}, uniformProps)) : React.createElement(GallerySimple, Object.assign({}, uniformProps))),
        props.type === 'ASYMMETRIC' && React.createElement(GallerySimple, Object.assign({}, asymmetricProps))))));
};
export default Gallery;
